// extracted by mini-css-extract-plugin
export default {"overflow":"ColumnFilter_overflow__yqkJK","forboredr":"ColumnFilter_forboredr__wn0GS","fontcolor":"ColumnFilter_fontcolor__44s6o"};